import { defineAsyncComponent } from 'vue';
import { AbstractModalService } from '@/core/modals/AbstractModalService';
import {
    RackExternalRackConfiguratorFormModalProps
} from '@/project/app/client-pages/rack-configurator/RackExternalRackConfiguratorFormModal.vue';

class ExternalRackConfiguratorGuideFormService extends AbstractModalService {
    public async show(props: RackExternalRackConfiguratorFormModalProps): Promise<any> {
        return this.showModal<boolean|any>({
            component: defineAsyncComponent(() => import('./RackExternalRackConfiguratorFormModal.vue')),
            componentAttrs: {
                settings: {
                    ...props
                },
            },
            options: {
                placement: 'center',
            }
        });
    }
}

export default new ExternalRackConfiguratorGuideFormService();
